module.exports = __webpack_public_path__ + "img/2D-2BHK-t2.a2557d10.png";